
import { PAYMENT_PATH } from "../../routes/routes";

const handlePaymentClick = (walletId, setIsExiting, createOrderData, navigate) => {
  setIsExiting(true);
  setTimeout(() => {
    navigate(`${PAYMENT_PATH}/${walletId}`, {
      state: { createOrderData },
    });
  }, 500);
};

export default handlePaymentClick;
